import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'dgx-achievement-detail',
  templateUrl: './achievement-detail.component.html',
  styleUrls: ['./achievement-detail.component.scss'],
})
export class AchievementDetailComponent implements OnInit {
  // bindings
  @Input() public title: string;
  @Input() public value: string;
  @Input() public href: string;

  @Input() public isLink: boolean = false;
  @Input() public isAttachment: boolean = false;
  @Input() public isClamped: boolean = false;
  @Input() public click: (event: Event) => void;
  @Input() public isLast: boolean = false;

  public isText: boolean = true;

  public ngOnInit() {
    this.isText = !this.isLink && !this.isAttachment && !this.isClamped;
  }
}
